import { useContext } from 'react';
import { LanguageContext } from '../context/LanguageContext';

/**
 * Access the chosen language and helpers:
 * { language, languageInfo, isRtl, supportedLanguages, changeLanguage, translationStatus }
 */
export const useLanguage = () => {
    const context = useContext(LanguageContext);
    if (!context) {
        throw new Error('useLanguage must be used inside <LanguageProvider>.');
    }
    return context;
};
